import { PropsWithChildren, ReactElement } from 'react';
import styles from './CellActions.module.scss';

interface CellActionsProps {
  wide?: boolean;
}

export const CellActions = ({
  wide = false,
  children,
}: PropsWithChildren<CellActionsProps>): ReactElement => {
  return (
    <div className={`${styles.cellActions} ${wide && styles['cellActions--wide']}`}>{children}</div>
  );
};

export default CellActions;
